import { Injectable } from '@angular/core';
import { Filter } from '../types/filter';
import { FilterProvider } from './filter.provider';

/**
 * Filters the given array based on the provided filter.
 * @deprecated This method is deprecated. Use `filer` function instead for better performance and flexibility.
 */
@Injectable()
export class FilterService {
  constructor(private provider: FilterProvider) {
  }

  filter<T>(values: T[], filter: Filter | null | undefined): T[] {
    if(!filter)
      return values;
    return values.filter(o => this.predicate(o, filter));
  }

  predicate<T>(value: T, filter: Filter): boolean {
    const predicate = this.provider.getFilter(filter.operator);
    return predicate(value, filter, (o) => this.provider.getFilter(o));
  }
}
